export const formWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px 24px 24px',
};

export const footerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  padding: '16px 24px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};
